// eslint-disable-next-line import/no-cycle
import { StoryblokComponent } from '@storyblok/react';

import Footer from '@/components/layouts/Footer';
import Header from '@/components/layouts/Header';
import Hero from '@/components/layouts/Hero';

const Page = ({ story, blok, settingsHeader, settingsFooter }) => (
  <>
    <Hero story={story} blok={blok} type="basic">
      <Header theme={blok.header_theme} settingsHeader={settingsHeader} />
    </Hero>
    <main role="main" id="main">
      {blok.body
        ? blok.body.map((blk) => (
            <StoryblokComponent blok={blk} key={blk._uid} />
          ))
        : null}
    </main>
    <Footer settingsFooter={settingsFooter} />
  </>
);

export default Page;
